import { render } from "./MenuMain.vue?vue&type=template&id=6b1a2b51&scoped=true"
import script from "./MenuMain.vue?vue&type=script&lang=js"
export * from "./MenuMain.vue?vue&type=script&lang=js"

import "./MenuMain.vue?vue&type=style&index=0&id=6b1a2b51&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-6b1a2b51"]])

export default __exports__